var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "region-environments-page" },
    [
      _c("div", { staticClass: "header row" }, [
        _c(
          "div",
          [
            _vm.latestUpdateOn
              ? _c("HKLGrayHint", [
                  _vm._v(
                    "\n        " + _vm._s(_vm.latestUpdateOn) + "\n      "
                  ),
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.showRestartHint
              ? _c("p", [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.$t("hint.regionConfig.requireRestart")) +
                      "\n      "
                  ),
                ])
              : _vm._e(),
          ],
          1
        ),
        _vm._v(" "),
        _vm.canEdit
          ? _c(
              "div",
              { staticClass: "btn-group" },
              [
                !_vm.isEdit
                  ? _c("HKLUploadButton", {
                      on: {
                        importFile: function (result) {
                          return _vm.importJson(result)
                        },
                      },
                    })
                  : _vm._e(),
                _vm._v(" "),
                !_vm.isEdit
                  ? _c("HKLButton", {
                      attrs: { color: "orange", action: "export" },
                      on: {
                        click: function () {
                          return _vm.exportJson()
                        },
                      },
                    })
                  : _vm._e(),
                _vm._v(" "),
                !_vm.isEdit
                  ? _c("HKLButton", {
                      attrs: { color: "orange", action: "edit" },
                      on: {
                        click: function () {
                          return _vm.changeEdit()
                        },
                      },
                    })
                  : _vm._e(),
                _vm._v(" "),
                _vm.isEdit
                  ? _c("HKLButton", {
                      attrs: { color: "darkblue", action: "cancel" },
                      on: {
                        click: function () {
                          return _vm.cancelEdit()
                        },
                      },
                    })
                  : _vm._e(),
                _vm._v(" "),
                _vm.isEdit
                  ? _c("HKLButton", {
                      attrs: { color: "orange", action: "save" },
                      on: {
                        click: function () {
                          return _vm.saveEnv()
                        },
                      },
                    })
                  : _vm._e(),
              ],
              1
            )
          : _vm._e(),
      ]),
      _vm._v(" "),
      _vm._l(_vm.list, function (type, key) {
        return _c(
          "Collapse",
          {
            key: "env-list-" + key,
            staticClass: "region-environments-collapse",
            attrs: {
              title: _vm.$t("settings.regionConfig.moduleTitle." + key),
              expand: false,
            },
          },
          [
            _c(
              "template",
              { slot: "content" },
              _vm._l(type, function (item, itemType) {
                return _c(
                  "HKLForm",
                  { key: "env-form-" + itemType, staticClass: "env-form" },
                  [
                    itemType === _vm.REGION_ENV_TYPE.JOBS &&
                    Object.keys(item).length
                      ? _c(
                          "div",
                          { staticClass: "environment-label-jobs-title" },
                          [
                            _vm._v(
                              "\n          " +
                                _vm._s(_vm.$t("settings.regionConfig.jobs")) +
                                "\n        "
                            ),
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm._l(item, function (content, index) {
                      return _c(
                        "div",
                        { key: "list-" + index },
                        [
                          _vm.isFormatByBuilding(content)
                            ? [
                                _vm._l(
                                  content.value,
                                  function (buildingContent, buildingIndex) {
                                    return _c(
                                      "div",
                                      {
                                        key:
                                          "special-with-building-" +
                                          buildingIndex,
                                        staticClass:
                                          "special-with-building-list",
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "list-title title-with-building small-4",
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "list-title-label small-6",
                                              },
                                              [
                                                _vm._v(
                                                  "\n                  " +
                                                    _vm._s(
                                                      buildingIndex === 0
                                                        ? index
                                                        : ""
                                                    ) +
                                                    "\n                "
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _vm.isEdit
                                              ? _c("HKLMultiSelect", {
                                                  staticClass:
                                                    "building-selection",
                                                  attrs: {
                                                    placeholder: "Building",
                                                    options:
                                                      _vm.buildingOptions,
                                                  },
                                                  model: {
                                                    value:
                                                      buildingContent.building,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        buildingContent,
                                                        "building",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "buildingContent.building",
                                                  },
                                                })
                                              : _c("div", [
                                                  _vm._v(
                                                    "\n                  " +
                                                      _vm._s(
                                                        buildingContent.building.join(
                                                          ", "
                                                        )
                                                      ) +
                                                      "\n                "
                                                  ),
                                                ]),
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _vm.isEdit
                                          ? _c("HKLTextarea", {
                                              staticClass: "small-7",
                                              model: {
                                                value: buildingContent.value,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    buildingContent,
                                                    "value",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "buildingContent.value",
                                              },
                                            })
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _vm.isEdit
                                          ? _c(
                                              "div",
                                              { staticClass: "small-1" },
                                              [
                                                (content.value || []).length > 1
                                                  ? _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "remove-btn",
                                                        on: {
                                                          click: function () {
                                                            return _vm.deleteRow(
                                                              {
                                                                itemModule: key,
                                                                itemType:
                                                                  itemType,
                                                                itemKey: index,
                                                                index:
                                                                  buildingIndex,
                                                              }
                                                            )
                                                          },
                                                        },
                                                      },
                                                      [
                                                        _c("i", {
                                                          staticClass:
                                                            "fa fa-times fa-lg",
                                                        }),
                                                      ]
                                                    )
                                                  : _vm._e(),
                                              ]
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        !_vm.isEdit
                                          ? _c(
                                              "p",
                                              { staticClass: "content-value" },
                                              [
                                                _vm._v(
                                                  "\n                " +
                                                    _vm._s(
                                                      buildingContent.value
                                                    ) +
                                                    "\n              "
                                                ),
                                              ]
                                            )
                                          : _vm._e(),
                                      ],
                                      1
                                    )
                                  }
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "row" },
                                  [
                                    _c("div", {
                                      staticClass:
                                        "list-title title-with-building small-4",
                                    }),
                                    _vm._v(" "),
                                    _vm.isEdit
                                      ? _c("HKLButton", {
                                          staticClass: "add-btn",
                                          attrs: { action: "addPlus" },
                                          on: {
                                            click: function () {
                                              return _vm.addRow(
                                                {
                                                  itemModule: key,
                                                  itemType: itemType,
                                                  itemKey: index,
                                                },
                                                {
                                                  building: [],
                                                  value: "",
                                                }
                                              )
                                            },
                                          },
                                        })
                                      : _vm._e(),
                                  ],
                                  1
                                ),
                              ]
                            : _vm.needTemplateNEntitlement(content)
                            ? [
                                _c("TemplateEntitlementList", {
                                  attrs: {
                                    isEdit: _vm.isEdit,
                                    contentValue: content.value,
                                    index: index,
                                    templates: _vm.wpTemplates,
                                    entitlements: _vm.entitlements,
                                    getEntitlementSelections:
                                      _vm.getEntitlementSelections,
                                    formatPermStr: _vm.formatPermStr,
                                    templateModule: key,
                                    onDelete: function (templateIndex) {
                                      return _vm.deleteRow(
                                        {
                                          itemModule: key,
                                          itemType: itemType,
                                          itemKey: index,
                                          index: templateIndex,
                                        },
                                        _vm.templatePermDefault
                                      )
                                    },
                                    onAdd: function () {
                                      return _vm.addRow(
                                        {
                                          itemModule: key,
                                          itemType: itemType,
                                          itemKey: index,
                                        },
                                        _vm.templatePermDefault
                                      )
                                    },
                                  },
                                  on: {
                                    "update:contentValue": function ($event) {
                                      return _vm.$set(content, "value", $event)
                                    },
                                    "update:content-value": function ($event) {
                                      return _vm.$set(content, "value", $event)
                                    },
                                  },
                                }),
                              ]
                            : _c(
                                "div",
                                { staticClass: "environment-list" },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "list-title small-4" },
                                    [
                                      _vm._v(
                                        "\n              " +
                                          _vm._s(index) +
                                          "\n            "
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _vm.isEdit
                                    ? _c("HKLTextarea", {
                                        directives: [
                                          {
                                            name: "autosize",
                                            rawName: "v-autosize",
                                          },
                                        ],
                                        staticClass: "content-value small-7",
                                        attrs: { disabled: content.readOnly },
                                        model: {
                                          value: content.value,
                                          callback: function ($$v) {
                                            _vm.$set(content, "value", $$v)
                                          },
                                          expression: "content.value",
                                        },
                                      })
                                    : _c(
                                        "p",
                                        { staticClass: "content-value" },
                                        [
                                          _vm._v(
                                            "\n              " +
                                              _vm._s(content.value) +
                                              "\n            "
                                          ),
                                        ]
                                      ),
                                ],
                                1
                              ),
                        ],
                        2
                      )
                    }),
                  ],
                  2
                )
              }),
              1
            ),
          ],
          2
        )
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }